import { HttpErrorResponse } from '@angular/common/http';
import { ModuleErrorView } from 'src/app/shared/errors/module-error.model';
import { gatewayHttpErrorMessage } from './errors';

export interface HttpEventLogContext extends Record<string, unknown> {
  endpointOrigen: string;
  codigoHttp?: number;
  codigoError?: string;
  message?: string;
}

function pickBusinessCode(body: unknown): string | undefined {
  if (body == null || typeof body !== 'object') {
    return undefined;
  }
  const code = (body as { code?: unknown }).code;
  return typeof code === 'string' && code.trim() ? code.trim() : undefined;
}

/** Extrae pathname de una URL absoluta del HttpClient. */
export function endpointFromHttpUrl(url: string | null | undefined): string | undefined {
  if (!url) {
    return undefined;
  }
  try {
    return new URL(url).pathname;
  } catch {
    return undefined;
  }
}

export function httpSuccessContext(
  endpointOrigen: string,
  codigoHttp = 200
): HttpEventLogContext {
  return { endpointOrigen, codigoHttp };
}

export function httpErrorContext(
  err: HttpErrorResponse,
  fallbackEndpoint: string
): HttpEventLogContext {
  const endpointOrigen =
    endpointFromHttpUrl(err.url) ?? fallbackEndpoint;
  const message = gatewayHttpErrorMessage(err);
  return {
    endpointOrigen,
    codigoHttp: err.status,
    codigoError: pickBusinessCode(err.error) ?? message,
    message,
  };
}

export function moduleErrorContext(
  error: ModuleErrorView,
  endpointOrigen: string
): HttpEventLogContext {
  return {
    endpointOrigen,
    codigoHttp: error.httpStatus,
    codigoError: error.code,
    message: error.message,
  };
}

export function httpContextFromUnknown(
  err: unknown,
  fallbackEndpoint: string
): HttpEventLogContext {
  if (err instanceof HttpErrorResponse) {
    return httpErrorContext(err, fallbackEndpoint);
  }
  if (err && typeof err === 'object' && 'code' in err && 'message' in err) {
    return moduleErrorContext(err as ModuleErrorView, fallbackEndpoint);
  }
  return {
    endpointOrigen: fallbackEndpoint,
    message: err instanceof Error ? err.message : String(err),
  };
}

export function mergeHttpLogPayload(
  base: Record<string, unknown>,
  httpContext: HttpEventLogContext
): Record<string, unknown> {
  return { ...base, ...httpContext };
}
